import { useEffect, useRef, useState } from "react";
import { InfoAccionistaService } from "../../service/matriz/InfoAccionistaService";
import { Generico } from "../../components/Generico";
import { MatrizComponent } from "../../components/MatrizComponent";
import { DetailedCellError, HyperFormula } from "hyperformula";
import { useForm } from "react-hook-form";
import { ProgressSpinner } from 'primereact/progressspinner';

export const DetalleAccionistaUno = ({ matrizId, permss, setDialogPerfil, toast, fecha, perfil, uno, regresarUno, regresar, funcionalidades }) => {

    const { control, formState: { errors }, handleSubmit, reset, setError } = useForm({});
    const accionistaSrv = new InfoAccionistaService();
    const [rango, setRango] = useState(null);
    const [matriz, setMatriz] = useState(null);
    const hfInstanceRef = useRef(null);
    const [loadSave, setLoadSave] = useState(false);
    const { funcError, funcSuccess, funcMessageBlobError, downloadPdf, limpiarNombre } = Generico();
    const [loadReport, setLoadReport] = useState(false);
    const [loadCambio, setLoadCambio] = useState(false);
    const [loadingDatos, setLoadingDatos] = useState(true);
    const [color, setColor] = useState(null);
    const { inDropAnio, inNumber2, numericRound, resume, generateRange, colorSenialDos, onError, buttonsMatriz, inTextArea } = MatrizComponent({ control, errors, permss, toast, color, funcionalidades });

    useEffect(() => {
        hfInstanceRef.current = HyperFormula.buildEmpty({ licenseKey: 'gpl-v3' });
        hfInstanceRef.current.addSheet('Sheet1');
        generateRange(setRango);
        verificarMatriz();
        return () => {
            hfInstanceRef.current.destroy();
        };
    }, [matrizId]);

    const valueCell = (field, value, row) => {
        const cols = { valor_anio1: 0, valor_anio2: 1, anio1: 0, anio2: 1, anio3sel: 4, edad: 5 };
        if (value) {
            hfInstanceRef.current.setCellContents({ sheet: 0, col: cols[field], row: row }, [[value]]);
        }
        const calculatedValue = hfInstanceRef.current.getCellValue({ sheet: 0, col: cols[field], row: row });
        if (calculatedValue instanceof DetailedCellError) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: `Error: ${calculatedValue.type}, Message: ${calculatedValue.message}, field: ${field}, value: ${value}, row: ${row}`, life: 3000 });
            return null;
        }

        return numericRound(calculatedValue) + (field === 'calculado2' && typeof calculatedValue === 'number' ? ' %' : '');
    }

    const verificarMatriz = () => {
        accionistaSrv.informacion(matrizId, uno, perfil).then(res => {
            const _info = res.data;
            setColor(_info?.color);
            valueCell('anio3sel', _info?.anio3, 0);
            valueCell('edad', _info?.edad, 0);
            const _values = {};
            _values.anio3 = _info?.anio3 ? { nombre: _info?.anio3 + "", cat_id: _info?.anio3 } : null;
            _values.justificacion_uno = _info.justificacion_uno ?? '';
            const data = [];
            const formulas = [];
            let index = 0;
            Object.keys(_info).map((key) => {
                const siMatriz = key.includes('eco') || key.includes('pat') || key.includes('sep');
                if (siMatriz) {
                    const orden = _info[key].orden;
                    if (_info[key]?.color.includes('MATRIZ_COLOR_CELESTE')) {
                        _values[`${key}-${orden}-valor_anio1`] = parseInt(_info[key]?.valor_anio1);
                    }
                    data.push([_info[key]?.valor_anio1, _info[key]?.valor_anio2]);
                    if (_info[key]?.anio1) formulas.push({ value: _info[key]?.anio1, row: index, col: 0 });
                    if (_info[key]?.anio2) formulas.push({ value: _info[key]?.anio2, row: index, col: 1 });
                    delete _info[key]?.anio1;
                    delete _info[key]?.anio2;
                    index++;
                }
                return 1;
            });
            hfInstanceRef.current.setCellContents(
                { sheet: 0, col: 0, row: 0 },
                data
            );
            formulas.forEach((formula) => {
                hfInstanceRef.current.setCellContents(
                    { sheet: 0, col: formula.col, row: formula.row },
                    [[formula.value]]
                );
            });
            setMatriz(_info);
            reset(_values);
            if (_info?.formulario) {
                calcular(_info.edad, 'edad1-1-edad', _info);
            }
        }).finally(() => setLoadingDatos(false));
    }

    const onChangeRango = (e, name) => {
        valueCell(`${name}sel`, e.value?.cat_id, 0);
        setMatriz(prevItem => ({
            ...prevItem,
            [name]: e.value?.cat_id
        }));
    };

    const calcular = (value, name, _mmatriz = null) => {
        const siNumber = name.includes('eco') || name.includes('pat');
        if (_mmatriz) {
            delete _mmatriz.inicio;
        }
        if (siNumber) {
            const _matriz = _mmatriz ?? matriz;
            delete _matriz.inicio;
            setMatriz(_matriz);
        }
        const [key, orden, field] = name.split('-');
        const rrow = parseInt(orden) - 1;
        let _item = null;
        if (key.includes('edad')) {
            _item = valueCell(field, value, rrow);
        } else {
            _item = matriz[key];
            _item[field] = valueCell(field, value, rrow);
        }

        const arrs = [3, 6, 7, 9, 10, 11, 14];
        let ftl = 'eco';
        arrs.forEach(itm => {
            if (itm === 14) ftl = 'pat';
            const _cal = _mmatriz ? _mmatriz[`${ftl}${itm}`] : matriz[`${ftl}${itm}`];
            _cal.valor_anio1 = valueCell('valor_anio1', null, itm - 1);
        });

        for (let i = 15; i <= 20; i++) {
            const _cams = ['valor_anio1'];
            if (i === 15 || i === 17) {
                _cams.push('valor_anio2');
            }
            const _cal = _mmatriz ? _mmatriz[`sep${i}`] : matriz[`sep${i}`];
            _cams.forEach(cl => {
                const res = valueCell(cl, null, i - 1);
                _cal[cl] = res;
                if (res === null) {
                    return;
                }
            });
        }
        if (_mmatriz) {
            setMatriz(_mmatriz);
        } else {
            setMatriz(prevItem => ({
                ...prevItem,
                [key]: _item
            }));
        }
    }

    const texto = (opc) => {
        return opc === 1 ? (
            <>
                <strong>Escalas de Evaluación:</strong>
                <br /><br />
                <strong>Índice patrimonial (Patrimonio / Ingresos anuales): Mide si el patrimonio acumulado es coherente con los ingresos.</strong><br />
                ≤2 (coherente) → 1 - muy bajo<br />
                2 - 5 → 2 - bajo<br />
                5 - 10 → 3 - medio<br />
                10 - 20 → 4 - alto<br />
                &gt;20 → 5 - muy alto
                <br /><br />
                <strong>Índice de gastos visibles (Gastos / Ingresos): Gastos mayores a ingresos generan alerta.</strong><br />
                ≤0.8 → 1 - muy bajo<br />
                0.8 - 1 → 2 - bajo<br />
                1 - 1.5 → 3 - medio<br />
                1.5 - 2 → 4 - alto<br />
                &gt;2 → 5 - muy alto
            </>
        ) : (
            <>
                <strong>Escalas de Evaluación:</strong>
                <br /><br />
                <strong>Nivel de endeudamiento (Pasivos / Ingresos anuales): Deudas elevadas pueden presionar al empleado a conductas de riesgo.</strong><br />
                ≤0.5 → 1<br />
                0.5 - 1 → 2<br />
                1 - 2 → 3<br />
                2 - 3 → 4<br />
                &gt;3 → 5
                <br /><br />
                <strong>Otros ingresos / Ingresos totales: Si la mayoría de ingresos no provienen del ingreso bajo relación de dependencia, es un riesgo.</strong><br />
                ≤5% → 1<br />
                5 - 15% → 2<br />
                15 - 30% → 3<br />
                30 - 50% → 4<br />
                &gt;50% → 5
            </>
        );
    };

    const onSubmit = (data) => {
        if (matriz?.inicio) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No puede guardar, debe ingresar la información de la matriz.', life: 3000 });
            return;
        }
        setLoadSave(true);
        const _matriz = matriz;
        _matriz.justificacion_uno = data.justificacion_uno;
        accionistaSrv.detalle(_matriz, uno, perfil).then(res => {
            setLoadSave(false);
            funcSuccess(res, toast);
        }).catch(error => {
            setLoadSave(false);
            funcError(error, toast, setError);
        });
    }

    const generarReporte = () => {
        if (matriz?.inicio) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No puede generar, debe ingresar la información de la matriz.', life: 3000 });
            return;
        }
        setLoadReport(true);
        const nombreArchivo = `Matriz - ${limpiarNombre(matriz.nombres)}.pdf`;
        accionistaSrv.descargar(matrizId, uno, perfil).then(res => {
            downloadPdf(res, nombreArchivo);
            setLoadReport(false);
        }).catch(error => {
            setLoadReport(false);
            funcMessageBlobError('Asegúrese de ingresar la información antes de generar el reporte.', error, toast);
        });
    }

    const infoEconomica = () => {
        const info = [];
        for (let num = 1; num <= 11; num++) {
            const bg1 = matriz[`eco${num}`].color.includes('MATRIZ_COLOR_CELESTE') ? 'yellow-100' : 'black-alpha-60';
            const bg2 = matriz[`eco${num}`].color.includes('MATRIZ_COLOR_CELESTE') ? 'blue-100' : 'black-alpha-60';
            const tc = matriz[`eco${num}`].color.includes('MATRIZ_COLOR_CELESTE') ? '' : 'text-white';
            info.push(resume((num * 100) + 1, '', 2, 0, false, 'xs', 'center', null, null));
            info.push(resume((num * 100) + 2, matriz[`eco${num}`].nombre, 6, 0, false, 'xs', 'center', bg1, `border-1 ${tc}`));
            if (matriz[`eco${num}`].color.includes('MATRIZ_COLOR_CELESTE')) {
                info.push(inNumber2(`eco${num}-${num}-valor_anio1`, 2, { chn: calcular, key: (num * 100) + 3 }));
            } else {
                info.push(resume((num * 100) + 3, matriz[`eco${num}`].valor_anio1, 2, 0, false, 'xs', 'center', bg2, `border-1 ${tc}`));
            }
            info.push(resume((num * 100) + 4, '', 2, 0, false, 'xs', 'center', null, null));
        }

        return info;
    }

    const infoPatrimonial = (ini = 12, fin = 14, fld = 'pat') => {
        const info = [];
        for (let num = ini; num <= fin; num++) {
            info.push(resume((num * 100) + 1, '', 4, 0, false, 'xs', 'center', null, null));
            info.push(resume((num * 100) + 2, matriz[`${fld}${num}`].nombre, 2, 0, false, 'xs', 'center', null, 'border-1'));
            if (matriz[`${fld}${num}`].color.includes('MATRIZ_COLOR_CELESTE')) {
                info.push(inNumber2(`${fld}${num}-${num}-valor_anio1`, 2, { chn: calcular, key: (num * 100) + 3 }));
            } else {
                info.push(resume((num * 100) + 3, matriz[`${fld}${num}`].valor_anio1, 2, 0, false, 'xs', 'center', 'yellow-100', `border-1`));
            }
            info.push(resume((num * 100) + 4, '', 4, 0, false, 'xs', 'center', null, null));
        }

        return info;
    }

    const infoSenial = () => {
        const info = [];
        info.push(
            <div key="senial-bloque-1" className="field col-8 m-0">
                <div className="h-full" style={{ display: 'grid', gridTemplateRows: '1fr 1fr 1fr' }}>
                    <div className="grid grid-nogutter align-items-stretch">
                        {resume(1501, '', 0, 0, false, 'xs', 'center', null, null)}
                        {resume(1502, matriz?.sep15?.nombre, 5, 0, true, 'xs', 'center', null, 'border-1 p-2')}
                        {resume(1503, matriz?.sep15?.valor_anio1, 2, 0, true, 'xs', 'center', matriz?.sep15?.valor_anio1, 'border-1')}
                        {resume(1504, matriz?.sep15?.valor_anio2, 5, 0, true, 'xs', 'center', colorSenialDos(matriz?.sep15?.valor_anio2), 'border-1')}
                    </div>
                    <div className="grid grid-nogutter align-items-stretch">
                        {resume(1601, '', 0, 0, false, 'xs', 'center', null, null)}
                        {resume(1602, matriz?.sep16?.nombre, 5, 0, true, 'xs', 'center', null, 'border-1 p-2')}
                        {resume(1603, matriz?.sep16?.valor_anio1, 2, 0, true, 'xs', 'center', colorSenialDos(matriz?.sep16?.valor_anio1), 'border-1')}
                    </div>
                    <div className="grid grid-nogutter align-items-stretch">
                        {resume(1701, '', 0, 0, false, 'xs', 'center', null, null)}
                        {resume(1702, matriz?.sep17?.nombre, 5, 0, true, 'xs', 'center', null, 'border-1 p-2')}
                        {resume(1703, matriz?.sep17?.valor_anio1, 2, 0, true, 'xs', 'center', matriz?.sep17?.valor_anio1, 'border-1')}
                        {resume(1704, matriz?.sep17?.valor_anio2, 5, 0, true, 'xs', 'center', colorSenialDos(matriz?.sep17?.valor_anio2), 'border-1')}
                    </div>
                </div>
            </div>
        );

        info.push(resume(1750, texto(1), 4, 0, false, '9px', 'center', null, 'border-1 p-2'));

        info.push(
            <div key="senial-bloque-2" className="field col-8 m-0">
                <div className="h-full" style={{ display: 'grid', gridTemplateRows: '1fr 1fr 1fr' }}>
                    <div className="grid grid-nogutter align-items-stretch">
                        {resume(1801, '', 0, 0, false, 'xs', 'center', null, null)}
                        {resume(1802, matriz?.sep18?.nombre, 7, 0, true, 'xs', 'center', null, 'border-1 p-2')}
                        {resume(1803, matriz?.sep18?.valor_anio1, 5, 0, true, 'xs', 'center', colorSenialDos(matriz?.sep18?.valor_anio1), 'border-1')}
                    </div>
                    <div className="grid grid-nogutter align-items-stretch">
                        {resume(1901, '', 0, 0, false, 'xs', 'center', null, null)}
                        {resume(1902, matriz?.sep19?.nombre, 7, 0, true, 'xs', 'center', null, 'border-1 p-2')}
                        {resume(1903, matriz?.sep19?.valor_anio1, 5, 0, true, 'xs', 'center', colorSenialDos(matriz?.sep19?.valor_anio1), 'border-1')}
                    </div>
                    <div className="grid grid-nogutter align-items-stretch">
                        {resume(2001, '', 0, 0, false, 'xs', 'center', null, null)}
                        {resume(2002, matriz?.sep20?.nombre, 7, 0, true, 'xs', 'center', null, 'border-1 p-2')}
                        {resume(2003, matriz?.sep20?.valor_anio1, 5, 0, true, 'xs', 'center', colorSenialDos(matriz?.sep20?.valor_anio1), 'border-1')}
                    </div>
                </div>
            </div>
        );
        info.push(resume(2050, texto(2), 4, 0, false, '9px', 'center', null, 'border-1 p-2'));

        return info;
    };

    const finalizar = () => {
        if (matriz?.inicio) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No puede finalizar, debe ingresar la información de la matriz.', life: 3000 });
            return;
        }
        setLoadCambio(true);
        accionistaSrv.finalizar({ id: matrizId, estado: 'BORRADOR', cambio: 'a' }, uno, perfil).then(res => {
            setLoadCambio(false);
            funcSuccess(res, toast);
            if (res.data === 'FINALIZADO_UNO') {
                regresar();
            } else {
                regresarUno(res.data);
            }
        }).catch(error => {
            setLoadCambio(false);
            funcMessageBlobError("Error", error, toast);
        });
    }

    return (
        <>
            {loadingDatos ? (
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "40vh", textAlign: "center", gap: "20px" }}>
                    <ProgressSpinner style={{ width: '70px', height: '70px' }} strokeWidth="6" fill="var(--surface-ground)" animationDuration="4s" />
                    <h2 style={{ fontSize: "12px", fontWeight: "bold", textTransform: "uppercase", letterSpacing: "1px" }}>
                        Cargando datos...
                    </h2>
                </div>
            ) : (
                <form onSubmit={handleSubmit(onSubmit, onError)}>
                    <div className="formgrid grid">
                        <div className="field col-4" style={{ marginTop: '1.85rem' }}>
                        </div>
                        {inDropAnio('anio3', rango, { lab: 'nombre', chn: onChangeRango, header: 'Período' }, 2)}
                    </div>
                    <div className="grid grid-nogutter" style={{ maxWidth: '100%', margin: 'auto' }}>
                        {resume(1, '', 2, 0, false, 'xs', 'center', null, null)}
                        {resume(2, 'INFORMACIÓN ECONÓMICA DEL ' + (perfil === 'n' ? 'ACCIONISTA / SOCIO' : 'EMPLEADO'), 6, 0, true, 'xs', 'center', null, 'border-1')}
                        <div className="field col-2 m-0 border-1">
                            <div className="grid grid-nogutter">
                                {resume(3, 'PERÍODO', 12, 0, true, 'xs', 'center', null, 'border-1')}
                                {resume(4, matriz?.anio3, 12, 0, true, 'xs', 'center', 'blue-100', 'border-1')}
                            </div>
                        </div>
                        {resume(5, '', 2, 0, false, 'xs', 'center', null, null)}
                        {matriz && infoEconomica()}
                    </div>
                    <br />

                    <div className="grid grid-nogutter" style={{ maxWidth: '100%', margin: 'auto' }}>
                        {resume(6, '', 4, 0, false, 'xs', 'center', null, null)}
                        {resume(7, 'INFORMACIÓN PATRIMONIAL DECLARADA POR EL ' + (perfil === 'n' ? 'ACCIONISTA / SOCIO' : 'EMPLEADO'), 4, 0, true, 'xs', 'center', null, 'border-1')}
                        {resume(8, '', 4, 0, false, 'xs', 'center', null, null)}

                        {resume(9, '', 4, 0, false, 'xs', 'center', null, null)}
                        {resume(10, 'PERÍODO:', 1, 0, true, 'xs', 'center', null, 'border-1')}
                        {resume(11, matriz?.anio3, 3, 0, true, 'xs', 'center', null, 'border-1')}
                        {resume(12, '', 4, 0, false, 'xs', 'center', null, null)}
                        {matriz && infoPatrimonial()}
                    </div>
                    <br />

                    <div className="grid grid-nogutter" style={{ maxWidth: '100%', margin: 'auto' }}>
                        {resume(13, '', 2, 0, false, 'xs', 'center', null, null)}
                        {resume(14, 'SEÑALES DE ALERTA:', 6, 0, true, 'sm', 'center', null, 'h-2rem')}
                        {resume(15, '', 4, 0, false, 'xs', 'center', null, null)}
                        {matriz && infoSenial()}

                        {resume(16, '', 0, 0, false, 'xs', 'center', null, null)}
                        {resume(17, 'Justificación', 6, 0, true, 'xs', 'center', null, 'border-1')}
                        {inTextArea('justificacion_uno', { rows: 2, cols: 15, col: 6 + ' border-1', req: false }, 6)}
                    </div>

                    <br />
                    {buttonsMatriz({
                        permss, btn1: { setDlg: (valor) => { regresar(); setDialogPerfil(valor); } }, btn2: { loadSave }, btn3: { loadReport, chn: generarReporte },
                        btn4: { msg: <><ul><li>Asegúrese de guardar la matriz antes de finalizar.</li><li>Si todavía no ingresa la Matriz a Dos años, no podrá hacerlo luego.</li></ul>¿Desea finalizar la matriz?</>, chn: finalizar, loadCambio }
                    })}
                </form>
            )}
        </>
    )
}
